import { useGetDataScienceMmmSegmentsQuery } from 'app/apis/queryApi';
import { RootState } from 'app/store';
import DropDownButtonLegacy from 'common/components/drop-downs/legacy/dropDownButtonLegacy';
import { DropDownItemType } from 'common/components/drop-downs/legacy/dropDownItemType';
import SimpleButtonContainerContent from 'common/components/drop-downs/legacy/simpleDropDownButtonContainerContent';
import { FC, useMemo } from 'react';
import { useDispatch, useSelector } from 'react-redux';
import { onSegmentChanged } from './header-controls.slice';

const MmmHeaderControls: FC<Record<string, unknown>> = () => {
  const dispatch = useDispatch();
  const { siteId } = useSelector((state: RootState) => state.selectedSite);
  const { selectedSegmentKey } = useSelector(
    (state: RootState) => state.mmmHeaderControls
  );
  const isPocModeActive = useSelector(
    (state: RootState) => state.pocToggle.isPocModeActive
  );

  const { data: segments, isLoading: isLoadingSegments } =
    useGetDataScienceMmmSegmentsQuery({ siteId });

  const segmentDropdowns = useMemo(() => {
    if (segments && segments.length > 0) {
      const segmentsToMap = isPocModeActive
        ? segments
        : segments.filter(
            (segment) => !segment.toUpperCase().startsWith('TESTING')
          );

      return segmentsToMap.map<DropDownItemType>((segment, index) => {
        return {
          key: segment,
          label: segment,
          isActive: selectedSegmentKey
            ? selectedSegmentKey === segment
            : index === 0
        };
      });
    }
  }, [segments, selectedSegmentKey, isPocModeActive]);

  const selectedDropdownItem = useMemo(() => {
    if (segmentDropdowns) {
      const segment = segmentDropdowns.find(
        (s) => s.key === selectedSegmentKey
      );
      return segment;
    }

    return undefined;
  }, [segmentDropdowns, selectedSegmentKey]);

  return (
    <>
      <div className="flex justify-between mb-3">
        <div>
          <div className="flex items-center">
            <div className="mr-3">
              {!isLoadingSegments &&
              segmentDropdowns &&
              selectedDropdownItem ? (
                <DropDownButtonLegacy
                  dropDownItems={segmentDropdowns}
                  selectDropDownItem={(selectedItem) =>
                    dispatch(onSegmentChanged(selectedItem))
                  }
                >
                  <SimpleButtonContainerContent
                    dropdownLabel={selectedDropdownItem.label}
                    additionalContainerStyling="bg-white rounded border border-neutral-200"
                    widthClass={'w-60'}
                  />
                </DropDownButtonLegacy>
              ) : (
                <></>
              )}
            </div>
          </div>
        </div>
      </div>
    </>
  );
};

export default MmmHeaderControls;
